export default __webpack_public_path__ + "static/media/blue-autumn.8de44654.png";